<template>
 <section>
   <div class="createForm">
    <!-- <button class="circle_btn" @click="isScheduleBoard = true">+</button> -->
    <span class="button is-success" @click="isScheduleBoard = true">スケジュールを作成</span>
    <div class="form">
      <b-modal width="680px" :active.sync="isScheduleBoard">
        <div class="schedulecard">
          <div class="header-form">
            <p>
              スケジュールを作成
            </p>
            <hr>
          </div>
        <b-field label="タイトル名">
          <b-input v-model="schedule.title"
                   placeholder="タイトル名を入力してください">
          </b-input>
        </b-field>
         <b-field label="タイムゾーン">
            <b-datepicker
              locale="ja-JP"
              v-model="schedule.date"
              placeholder="クリックして選択してください">
            </b-datepicker>
        </b-field>
         <b-field label="開始時刻">
            <b-timepicker
              v-model="schedule.startTime"
              placeholder="クリックして選択してください">
           </b-timepicker>
         </b-field>
         <b-field label="終了時刻">
             <b-timepicker
                  v-model="schedule.endTime"
                  placeholder="クリックして選択してください"
                  :min-time="minTime">
             </b-timepicker>
         </b-field>
         <span class="button is-primary" @click="addEvent()" v-if="isScheduleBoard">保存する</span>
        </div>
      </b-modal>
    </div>
  </div>
 </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CreateSchedule',
  computed: {
    ...mapState('auth', ['user']),
    minTime: function () {
      return this.schedule.startTime
    }
  },
  data () {
    return {
      isScheduleBoard: false,
      schedule: {
        title: '',
        // date: new Date(),
        startTime: new Date(new Date().toLocaleString('ja-JP')),
        endTime: new Date(new Date().toLocaleString('ja-JP')),
        email: ''
      }
    }
  },
  methods: {
    addEvent () {
      console.debug('*** Start *** addEvent')
      this.schedule['email'] = this.user.email
      this.$store.dispatch('calendar/addEvent', this.schedule)
      this.isScheduleBoard = false
      console.debug('*** End *** addEvent')
    }
  }
}
</script>
<style scoped>
.schedulecard {
  background-color:white;
  padding: 40px 40px 100px 40px;
  border-radius: 10px;
}

.createForm {
  margin: 0px 10px;
}

p {
  font-size: 20px;
  font-weight: 600;
}

.button.is-primary {
    margin: 10px 0px 0px 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/CreateSchedule.vue